import { WEEKDAYS } from '@/constants/weekdays';
import { HotelSupplementFormData } from '@/types/benefits/hotel/HotelSupplementSchema';

const buildEmptyPricing = () => ({
  adultPrice: null as number | null,
  childPrice: null as number | null,
  adolescentPrice: null as number | null,
});

export const buildEmptyHotelSupplementPeriod = () => ({
  startDate: null as Date | null,
  endDate: null as Date | null,
  applicationDays: WEEKDAYS,
});

export const buildEmptyHotelSupplementPricing = () => ({
  name: '',
  periods: [buildEmptyHotelSupplementPeriod()],
  pricing: buildEmptyPricing(),
});

export const buildEmptyHotelSupplement = (): HotelSupplementFormData => ({
  id: undefined,
  name: '',
  pensionTypes: [],
  pricingList: [buildEmptyHotelSupplementPricing()],
});
